import React, { useEffect, useState } from 'react';
import { PageLink, PageTitle } from '../../layout/core';
import { useMerchants } from '../../store/merchnts/merchants-context';
import './Batches.scss';
import { useTranslation } from 'react-i18next';
import { exportCSVBatchesData } from '../../store/order/actions/exports';
import { BatchesFilterSection, IBatchesFiltersParams } from '../../components/batches/BatchesFilterSection';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { fetchWhiteListedPartnersList } from '../../store/merchnts/actions/partners';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { getFormattedDate } from '../../utils/utilities';
import { usePaymentContext } from '../../store/payments/payments-context';
import {
	fetchBatchData,
	fetchUnpostedBatchData,
	setBatchesDataToDefault,
} from '../../store/payments/actions/batches';
import { UnpostedBatchesList } from '../../components/batches/UnpostedBatchesList';
import { BatchesList } from '../../components/batches/BatchesList';

export const batchesBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.FUNDS',
		path: '/funds/payouts',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export enum EXPORT_NAME {
	PAYOUT = 'export-pending',
	UNPOSTED_PAYOUT = 'export',
	SHELVED_PAYOUT = 'export-shelved'
}

export interface IAdjustmentModalStateProps {
	isOpen: boolean,
	paymentId?: string,
}

export const BatchesListPage = (): JSX.Element => {
	const { t } = useTranslation();
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	const { merchantState: { chosenMerchant }, dispatch: merchantDispatch } = useMerchants();

	const { dispatch } = usePaymentContext();

	const [batchType, setBatchType] = useState<string[]>([]);
	const [partnerId, setPartnerId] = useState<string>('');
	const [yearAndMonth, setYearAndMonth] = useState<Date>(null);
	const [searchValue, setSearchValue] = useState<string>('');

	const [isBatchesExportLoading, setIsBatchesExportLoading] = useState<boolean>(false);
	const [isUnpostedBatchesExportLoading, setIsUnpostedBatchesExportLoading] = useState<boolean>(false);
	const [localLoading, setLocalLoading] = useState<boolean>(true);

	const getFetchParams = (): IBatchesFiltersParams => {
		return {
			merchantid: searchValue ? searchValue : chosenMerchant,
			batchType,
			partnerId,
			yearAndMonth: yearAndMonth ? getFormattedDate(yearAndMonth, 'yyyy-MM') : null,
		};
	};

	const fetchExportData = async (exportName: string): Promise<void> => {

		switch (exportName) {
			case EXPORT_NAME.PAYOUT:
				setIsBatchesExportLoading(true);
				await exportCSVBatchesData({ exportName, params: getFetchParams() });
				setIsBatchesExportLoading(false);
				break;
			case EXPORT_NAME.UNPOSTED_PAYOUT:
				setIsUnpostedBatchesExportLoading(true);
				await exportCSVBatchesData({ exportName, params: getFetchParams() });
				setIsUnpostedBatchesExportLoading(false);
				break;
		}
	};

	useEffect(() => {
		if (checkRoles(authUser, CLAIMS.SUPER_ADMIN)) {
			void fetchWhiteListedPartnersList(merchantDispatch);
		}
	}, []);

	useEffect(() => {
		return () => {
			setBatchesDataToDefault(dispatch);
		};
	}, []);

	const listener = async (searchParams: IBatchesFiltersParams): Promise<void> => {
		setLocalLoading(true);
		let localParams: IBatchesFiltersParams;

		if (Object.keys(searchParams).length) {
			localParams = { ...searchParams };

			setPartnerId(searchParams?.partnerId ?? '');
			setYearAndMonth(searchParams?.yearAndMonth ? new Date(searchParams?.yearAndMonth) : null);
			setSearchValue(searchParams?.query ?? '');

			if (searchParams?.batchType && typeof searchParams?.batchType === 'string') {
				setBatchType([searchParams?.batchType]);
			} else {
				setBatchType(searchParams?.batchType ?? []);
			}
		} else {
			localParams = {
				merchantid: chosenMerchant,
			};
		}

		await fetchUnpostedBatchData({ dispatch, params: localParams });
		await fetchBatchData({ dispatch, params: localParams });

		setLocalLoading(false);
	};

	return (
		<>
			<PageTitle breadcrumbs={batchesBreadCrumbs}>{t('MENU.PAYOUTS')}</PageTitle>

			{/*<BatchesFilterSection*/}
			{/*	batchType={batchType}*/}
			{/*	setBatchType={setBatchType}*/}
			{/*	partnerId={partnerId}*/}
			{/*	setPartnerId={setPartnerId}*/}
			{/*	yearAndMonth={yearAndMonth}*/}
			{/*	setYearAndMonth={setYearAndMonth}*/}
			{/*	query={searchValue}*/}
			{/*	setQuery={setSearchValue}*/}
			{/*/>*/}

			{/*<UnpostedBatchesList*/}
			{/*	isUnpostedBatchesExportLoading={isUnpostedBatchesExportLoading}*/}
			{/*	fetchExportData={fetchExportData}*/}
			{/*	listener={listener}*/}
			{/*	localLoading={localLoading}*/}
			{/*/>*/}

			{/*<BatchesList*/}
			{/*	isBatchesExportLoading={isBatchesExportLoading}*/}
			{/*	fetchExportData={fetchExportData}*/}
			{/*	localLoading={localLoading}*/}
			{/*/>*/}

		</>
	);
};
